import { castArray, uniq } from "lodash-es";

type NormalizeStringArrayOptions = {
  trim?: boolean;
  sort?: boolean;
};

export function normalizeStringArray(
  value: unknown,
  options: NormalizeStringArrayOptions = {},
): string[] {
  const strings = castArray(value)
    .filter((item): item is string => typeof item === "string")
    .map((item) => (options.trim ? item.trim() : item))
    .filter((item) => item.length > 0);
  const values = uniq(strings);

  return options.sort ? [...values].sort() : values;
}
